//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React from 'react'
import Reflux from 'reflux'
import BankStore from '../../store/bankstore'

const stepsPadding = {
    padding: '0 238px 0px 238px'
}

class HeaderSteps extends Reflux.Component {

    constructor(props) {
        super()
        this.state = {
            currentStep: props.currentStep,
            nextStep: null
        }
        this.store = BankStore
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            currentStep: nextProps.currentStep
        })
    }

    prevStep = step => {
        if (this.state.currentStep <= step) return
        this.props.prevStep(step)
    }

    render() {
        return (
            <div className="steps-container">
                <div className="container">
                    <div className="row ">
                        <ul className="breadcrumb">
                            <li onClick={(step) => this.prevStep(1)}><a style={stepsPadding} className='visited'>1. Feltöltés</a></li>
                            <li><a style={stepsPadding} className={this.state.currentStep > 1 ? 'visited' : ''}>2. Letöltés</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default HeaderSteps


// WEBPACK FOOTER //
// ./src/components/cashregister/headersteps.js